import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { GlobalContext } from "../../context/GlobalContext";

function DocumentCard({ title, link }) {
  const { isMobile } = React.useContext(GlobalContext);

  return (
    <div className={`document-container ${isMobile ? "col-5" : "col-lg-2"}`}>
      <a
        href={link}
        target={isMobile ? "_self" : "_blank"}
        className="document-container-link"
      >
        <div className="document-container-header">
          <FontAwesomeIcon
            className="document-container-icon"
            icon={faFileLines}
          />
        </div>

        <div className="document-container-title">
          <h6
            className="document-container-title-overflow text-left"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={title}
          >
            {title}
          </h6>
        </div>
      </a>
    </div>
  );
}

export default DocumentCard;
